import React from "react";
import {
  Column,
  DataGrid,
  Paging,
  Pager,
  FilterRow,
  FormItem,
  Lookup,
} from "devextreme-react/data-grid";
import { Editing } from "devextreme-react/scheduler";
import PaginaToolbar from "../components/PaginaToolbar";
import {
  criarRetencaoExternaDs,
  criarDocumentosRetencaoDs,
  criarContribuinteDs,
} from "../DataSources";
import UserInfo from "../UserInfo";
import uiInfo from "../ui-info";

export default class RetencaoExternaBox extends React.Component {
  constructor() {
    super();
    this.initNewRow = this.initNewRow.bind(this);
  }

  render() {
    return (
      <div className={"content-block dx-card responsive-paddings"}>
        <PaginaToolbar titulo="Retenções Externas">
          <DataGrid
            dataSource={criarRetencaoExternaDs()}
            showBorders={true}
            rowAlternationEnabled={true}
            remoteOperations={true}
            focusedRowEnabled={true}
            columnAutoWidth={true}
            columnHidingEnabled={true}
            wordWrapEnabled={true}
            filterSyncEnabled={true}
            onInitNewRow={this.initNewRow}
          >
            <FilterRow visible={true} />
            <Editing
              mode={"row"}
              allowAdding={false}
              allowUpdating={true}
              allowDeleting={true}
            />
            <Column
              dataField={"id"}
              caption={"#"}
              allowEditing={false}
              alignment={"center"}
              width={80}
            />
            <Column
              dataField={"prefeituraId"}
              caption={"Prefeitura"}
              visible={false}
            >
              <FormItem visible={false}></FormItem>
            </Column>
            <Column dataField={"data"} dataType={"date"} caption={"Data"} />
            <Column dataField={"tipo"} caption={"Tipo"}>
              <Lookup
                dataSource={criarDocumentosRetencaoDs()}
                valueExpr={"id"}
                displayExpr={"descricao"}
              />
            </Column>
            <Column dataField={"entidade"} caption={"Entidade"} />
            <Column
              dataField={"valor"}
              caption={"Valor"}
              format={{ type: "fixedPoint", precision: 2 }}
            />
            <Column dataField={"contribuinteId"} caption={"Contibuinte"}>
              <Lookup
                dataSource={criarContribuinteDs()}
                valueExpr={"id"}
                displayExpr={"nome"}
              />
            </Column>
            <Paging defaultPageSize={uiInfo.tamanhoPaginaPadrao} />
            <Pager
              showPageSizeSelector={true}
              allowedPageSizes={uiInfo.tamanhoPaginaOpcoes}
            />
          </DataGrid>
        </PaginaToolbar>
      </div>
    );
  }

  initNewRow(e) {
    e.data.prefeituraId = UserInfo.getPrefeitura();
  }
}
